<template>
  <div id="dashboard">
    <dashboard-header />
    <latest-releases />
    <dashboard-footer />
  </div>
</template>

<script>
import DashboardHeader from './DashboardHeader.vue'
import LatestReleases from './LatestReleases.vue'
import DashboardFooter from './DashboardFooter.vue'

export default {
  name: 'dashboard',
  components: { DashboardHeader, LatestReleases, DashboardFooter }
}
</script>

<style>

html {
  box-sizing: border-box;
  margin: 0;
}
*, *:before, *:after {
  box-sizing: inherit;
}

body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0;
}

</style>



// WEBPACK FOOTER //
// Dashboard.vue?2a2e6cc2